<section class="vm-row center" [id]="data?.id">
  <h2 *ngIf="data?.title">
    {{ data?.title }}
  </h2>
  <vm-markdown *ngIf="data?.copy" [data]="data?.copy"></vm-markdown>
  <form [formGroup]="form" autocomplete="off" (ngSubmit)="submitForm(data.submitLink)">
    <div class="vm-row center" *ngIf="form.get('firstName') as firstNameField">
      <div class="vm-col-lg-6 vm-col-md-6 vm-col-sm-8 vm-col-xs-12">
        <vm-text-input
          [classList]="'form-control'"
          formControlName="firstName"
          name="firstName"
          type="text"
          [required]="true"
          [isError]="showError || (firstNameField.invalid && (firstNameField.dirty || firstNameField.touched))"
          [errorMessage]="data?.firstNameError"
          [label]="data?.firstNameLabel">
        </vm-text-input>
      </div>
    </div>
    <div class="vm-row center" *ngIf="form.get('surname') as surnameField">
      <div class="vm-col-lg-6 vm-col-md-6 vm-col-sm-8 vm-col-xs-12">
        <vm-text-input
          [classList]="'form-control'"
          formControlName="surname"
          name="surname"
          type="text"
          [required]="true"
          [isError]="showError || (surnameField.invalid && (surnameField.dirty || surnameField.touched))"
          [errorMessage]="data?.lastNameError"
          [label]="data?.lastNameLabel">
        </vm-text-input>
      </div>
    </div>
    <div class="vm-row center" *ngIf="form.get('emailAddress') as emailAddressField">
      <div class="vm-col-lg-6 vm-col-md-6 vm-col-sm-8 vm-col-xs-12 email-number">
        <vm-text-input
          [classList]="'form-control'"
          formControlName="emailAddress"
          name="emailAddress"
          type="email"
          [required]="true"
          [isError]="showError || (!emailAddressField.value && (emailAddressField.dirty || emailAddressField.touched))"
          [errorMessage]="data?.emailError"
          [label]="data?.emailLabel">
        </vm-text-input>
      </div>
    </div>
    <div class="vm-row center">
      <div class="vm-col-lg-6 vm-col-md-6 vm-col-sm-8 vm-col-xs-12 submit">
        <vm-button
          id="upgrade360Btn"
          class="upgrade-360-link"
          [type]="buttonType.SUBMIT"
          [level]="buttonLevel.PRIMARY">
          {{ data?.submitLabel }}</vm-button
        >
      </div>
    </div>
  </form>
</section>
